<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-3">
            <li>
              <router-link to="/financial_activity_mappings" class="">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </router-link>
            </li>
            <li>
              <h3>{{ $t("accounting.label.editfinancialactivitymapping") }}</h3>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("accounting.label.financialactivity")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('accounting.label.financialactivity')"
                >
                <v-select
                  label="name"
                  v-model="financialActivity"
                  @input="handleChange"
                  :options="TemplateData.financialActivityOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div
              v-if="financialActivity"
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
            >
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("accounting.label.accountname")
                }}</small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('accounting.label.accountname')"
                >
                <v-select
                  label="name"
                  v-model="accountName"
                  :options="accountOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.name }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="$router.push('/financial_activity_mappings')"
            >{{ $t("system.label.cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="handleSubmit"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      financialActivity: "",
      accountName: "",
      warningPopup: false,
      warningText: "",
      errorMessage: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      TemplateData: (state) => state.accounting.financialActivityTemplateData,
      FinancialActivityData: (state) => state.accounting.financialActivityData,
    }),
    accountOptions() {
      if (!this.financialActivity) return [];
      if (!this.TemplateData.financialActivityOptions) return;
      const selectedActivity = this.TemplateData.financialActivityOptions.find(
        (activity) => activity.id === this.financialActivity
      );

      switch (selectedActivity.mappedGLAccountType) {
        case "ASSET":
          return this.TemplateData.glAccountOptions.assetAccountOptions;
        case "LIABILITY":
          return this.TemplateData.glAccountOptions.liabilityAccountOptions;
        case "INCOME":
          return this.TemplateData.glAccountOptions.incomeAccountOptions;
        case "EXPENSE":
          return this.TemplateData.glAccountOptions.expenseAccountOptions;
        case "EQUITY":
          return this.TemplateData.glAccountOptions.equityAccountOptions;
        default:
          return [];
      }
    },
  },
  methods: {
    async getTemplateData() {
      try {
        await this.$store.dispatch(
          "accounting/financialActivityTemplateAction"
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async handleChange() {
      this.accountName = null;
    },
    async getTemplateDataById() {
      try {
        await this.$store.dispatch(
          "accounting/viewFinancialActivityDataByIdAction",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.financialActivity =
        this.FinancialActivityData.financialActivityData.id;
      this.accountName = this.FinancialActivityData.glAccountData.id;
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        id: this.id,
        data: {
          financialActivityId: this.financialActivity,
          glAccountId: this.accountName,
        },
      };
      try {
        await this.$store.dispatch(
          "accounting/updateFinancialActivityMappingAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Mapping Updated Successfully!",
          type: "success",
        });
        this.resetForm();
        this.$router.push("/financial_activity_mappings");
      } catch (error) {
        const errorMessage = String(error.httpStatusCode).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.event = null;
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getTemplateDataById();
    this.getTemplateData();
  },
};
</script>
